import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      style={{ background: "var(--black)", color: "var(--ivory)", padding: "80px 24px 40px" }}
      data-testid="footer"
    >
      <div className="container-x">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div>
            <div className="brand-mark" style={{ marginBottom: 20 }}>SAVIAR</div>
            <p className="body-sm" style={{ maxWidth: 260 }}>
              A luxury wellness residence for women who choose softness as a standard.
              Washington, DC.
            </p>
          </div>
          <div>
            <p className="eyebrow" style={{ marginBottom: 20 }}>Explore</p>
            <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: 12 }}>
              <li><Link to="/experiences" style={{ color: "rgba(250,246,238,.6)", fontSize: ".88rem", textDecoration: "none" }}>Experiences</Link></li>
              <li><Link to="/society" style={{ color: "rgba(250,246,238,.6)", fontSize: ".88rem", textDecoration: "none" }}>The Society</Link></li>
              <li><Link to="/about" style={{ color: "rgba(250,246,238,.6)", fontSize: ".88rem", textDecoration: "none" }}>Our Story</Link></li>
              <li><Link to="/blog" style={{ color: "rgba(250,246,238,.6)", fontSize: ".88rem", textDecoration: "none" }} data-testid="footer-blog">Blog</Link></li>
              <li><Link to="/apply" style={{ color: "rgba(250,246,238,.6)", fontSize: ".88rem", textDecoration: "none" }}>Apply</Link></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow" style={{ marginBottom: 20 }}>Contact</p>
            <p className="body-sm">info@saviar.online</p>
            <p className="body-sm">Washington, DC</p>
          </div>
          <div>
            <p className="eyebrow" style={{ marginBottom: 20 }}>Follow</p>
            <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: 12 }}>
              <li>
                <a
                  href="https://www.instagram.com/saviar__la/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "rgba(250,246,238,.6)", fontSize: ".88rem", textDecoration: "none" }}
                  data-testid="footer-instagram"
                >
                  Instagram — @saviar__la
                </a>
              </li>
              <li>
                <a
                  href="https://www.tiktok.com/@saviar.dc"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "rgba(250,246,238,.6)", fontSize: ".88rem", textDecoration: "none" }}
                  data-testid="footer-tiktok"
                >
                  TikTok — @saviar.dc
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div style={{ borderTop: "1px solid rgba(184,150,90,.15)", paddingTop: 24, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
          <p style={{ color: "rgba(250,246,238,.35)", fontSize: ".78rem" }}>© {new Date().getFullYear()} Saviar Society. All rights reserved.</p>
          <p style={{ color: "rgba(250,246,238,.35)", fontSize: ".78rem" }}>
            <Link to="/privacy-policy" style={{ color: "inherit", textDecoration: "none" }} data-testid="footer-privacy">Privacy</Link>
            {" · "}
            <Link to="/terms-and-conditions" style={{ color: "inherit", textDecoration: "none" }} data-testid="footer-terms">Terms</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
